export default "__VITE_ASSET__73d73cd9__"